import classNames from 'classnames/bind'
import { FrontendRoadmapBanner } from 'apps/main/libs/roadmap/feature-frontend-roadmap-banner'
import { ReactElement } from 'react-markdown/lib/react-markdown'
import styles from './RoadmapLayout.module.scss'

const cx = classNames.bind(styles)

type RoadmapLayoutProps = {
  roadmap: ReactElement
}

export const RoadmapLayout = ({ roadmap }: RoadmapLayoutProps) => {
  return (
    <div className={cx('container')}>
      <FrontendRoadmapBanner />
      {roadmap}
    </div>
  )
}
